var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLockIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 0C8.8995 0 11.25 2.1938 11.25 4.9V5.6C11.6642 5.6 12 5.9134 12 6.3V13.3C12 13.6866 11.6642 14 11.25 14H0.75C0.335786 14 0 13.6866 0 13.3V6.3C0 5.9134 0.335786 5.6 0.75 5.6V4.9C0.75 2.1938 3.10051 0 6 0ZM6 7.7C5.17157 7.7 4.5 8.3268 4.5 9.1C4.5 9.61818 4.80162 10.0706 5.24995 10.3127L5.25 11.9333C5.25 12.3015 5.5698 12.6 5.96429 12.6H6.03571C6.4302 12.6 6.75 12.3015 6.75 11.9333L6.75081 10.3123C7.19871 10.0701 7.5 9.61789 7.5 9.1C7.5 8.3268 6.82843 7.7 6 7.7ZM6 1.4C3.92893 1.4 2.25 2.967 2.25 4.9V5.6H9.75V4.9C9.75 2.967 8.07107 1.4 6 1.4Z",
    fill: "#01313D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockIcon);
export default __webpack_public_path__ + "static/media/lock-icon.e04720912bcd3fdede456dfcbc0f2098.svg";
export { ForwardRef as ReactComponent };